import { scaleOrdinal } from 'd3-scale';
import type {
  Visualization,
  ChoicesData,
  ChoicesStaticOptions,
} from '../types';
import { DotsGrid } from './dots-grid';
import { Option } from './option';

export const Dots = ({
  width,
  height,
  colors,
  data,
  staticOptions,
  disableAnimations,
  keyAccessor = (d: ChoicesData | ChoicesStaticOptions) => d.id.toString(),
  labelAccessor = (d: ChoicesStaticOptions) => d.label,
  valueAccessor = (d: ChoicesData) => d.score,
  isScoreHidden,
}: Visualization<ChoicesData, ChoicesStaticOptions> & {
  isScoreHidden: boolean;
}) => {
  const rootHeight = Math.max(height, 0);
  const rootWidth = Math.max(width, 0);

  const discreteValuesBasedOnId = staticOptions.map(keyAccessor);

  const fillColors = scaleOrdinal(colors).domain(discreteValuesBasedOnId);

  if (rootWidth <= 0 || rootHeight <= 0) {
    return null;
  }

  return (
    <DotsGrid width={rootWidth} height={rootHeight} aria-hidden>
      {staticOptions.map((option, i) => {
        const dataValue = data.find((d) => d.id === option.id);

        return (
          <Option
            key={keyAccessor(option)}
            width={0}
            height={0}
            label={labelAccessor(option)}
            color={fillColors(keyAccessor(option))}
            score={dataValue ? valueAccessor(dataValue) : 0}
          />
        );
      })}
    </DotsGrid>
  );
};
